import React from 'react';
import './RequestSentModal.css';

function RequestSentModal({ onClose }) {
  return (
    <div className="modal-overlay confirmation-overlay" onClick={onClose}>
      <div className="modal-content confirmation-content" onClick={(e) => e.stopPropagation()}>
        <button className="confirmation-close-button" onClick={onClose}>×</button>
        <h2>Your request has been sent to the host.</h2>
        <p>We'll notify you as soon as they respond!</p>
        {/* Optionally add an OK button that calls onClose */}
        {/* <button onClick={onClose}>OK</button> */}
      </div>
    </div>
  );
}

export default RequestSentModal; 